<template lang="pug">
v-toolbar(
    :color="editMode ? 'brown' : activeTransaction.color"
    dark)
    //- v-toolbar-side-icon
    //-     v-icon star
    //- span.title.mr-4 Venta
    //transaction-selector.mr-4
    dte-selector-button
    .controls-area.d-flex.justify-space-around
        //search-box#searchbox.searchbox-area(
            ref="searchbox"
            :service="ProductService"
            @blur="blurHandler"
            @input="searchHandler($event)"
            :displayAttributes="['name', 'internal_code', 'upc_code']"
            )
        actions-menu.actionsmenu-area
    session-box(
        :infoSession="infoBoxSession"
        :htmlPrint="htmlPrint"
        @toggle:html:print="showAuth = true"
        )
    AuthModal(
        v-model="showAuth"
        :color="activeTransaction.color"
        @submit="submitAuth($event)"
        )
        template(slot="content")
            span.red--text(v-if="authError") {{authError}}
</template>

<script>
import SearchBox from '@/components/SearchBox/SearchBox'
import { mapActions, mapGetters, mapState } from 'vuex'
import ActionsMenu from '../ActionsMenu/ActionsMenu'
import * as ProductService from '@/services/API/ProductService.js'
import DTESelectorButton from './subcomponents/DTESelectorButton'
import SessionBox from '@/components/SessionBox/SessionBox'
import AuthModal from '@/components/SimpleAuth/AuthModal'
/**
 * Toolbar component for the SalePoint, includes a searchbox for items and
 * a main menu with routes for the difrent subviews of the salepoint
 */
export default {
    name: 'sales-toolbar',
    props: {},
    data: function() {
        return {
            /**
             * @description
             * Prop for setting the service that will handle the searchbox queries
             */
            ProductService: ProductService,
            /**
             * @description
             * Object that contains the data returned by the searchbox
             */
            searchResult: {},
            serive: ProductService,
            infoLog: {
                name: 'workstation 1',
                location: 'La Serena',
            },

            showAuth: false,
            authError: null,
        }
    },
    computed: {
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
        ...mapState('TransactionModule', {
            editMode: 'editMode',
        }),
        ...mapState('SessionModule', ['htmlPrint']),
        /*
         */
        infoBoxSession() {
            let user = JSON.parse(localStorage.getItem('user'))
            let infoLog = {}
            infoLog.name = `${user.last_name1} ${user.last_name2}`
            infoLog.location = user.g_branch_office.name
            //
            return infoLog
        },
    },
    methods: {
        /**
         * @description
         * handle what to do when searchbox returns data
         */
        searchHandler(item) {
            this.addItemToCart(item)
        },
        ...mapActions('CartModule', {
            addItemToCart: 'addItemToCart',
        }),
        ...mapActions('SessionModule', ['setHtmlPrint']),
        ...mapActions('AuthModule', ['authorizeSupervisor']),
        submitAuth(e) {
            this.authorizeSupervisor({ code: e })
                .then(() => {
                    this.setHtmlPrint(!this.htmlPrint)
                    this.authError = null
                    this.showAuth = false
                })
                .catch(e => (this.authError = e))
        },
    },
    watch: {},
    components: {
        'search-box': SearchBox,
        'actions-menu': ActionsMenu,
        'dte-selector-button': DTESelectorButton,
        'session-box': SessionBox,
        AuthModal,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.controls-area {
    width: 100%;
    .searchbox-area {
        width: 40%;
    }
    .actionsmenu-area {
        width: 60%;
    }
}

@media screen and(max-width: 959px) {
    .controls-area {
        .searchbox-area {
            width: 90%;
        }
        .actionsmenu-area {
            width: 10%;
        }
    }
}
</style>
